exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-loading[data-v-2499d5ff]{position:relative;overflow:hidden;border-radius:15px;height:100px;width:100%;background:#e5e7eb}.card-loading[data-v-2499d5ff]:before{content:\"\";position:absolute;top:0;left:-150px;height:100%;width:150px;background:-webkit-gradient(linear,left top,right top,from(transparent),color-stop(hsla(0,0%,100%,.6)),to(transparent));background:linear-gradient(90deg,transparent,hsla(0,0%,100%,.6),transparent);-webkit-animation:skeleton-loading-data-v-2499d5ff 1.2s infinite;animation:skeleton-loading-data-v-2499d5ff 1.2s infinite}@-webkit-keyframes skeleton-loading-data-v-2499d5ff{0%{left:-150px}to{left:100%}}@keyframes skeleton-loading-data-v-2499d5ff{0%{left:-150px}to{left:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2499d5ff","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/system/payments/components/card-loading.vue
// module id = GxC1
// module chunks = 0